'use strict';
const Fetcher = require('od-modules/utils/fetcher');
const trackingUtils = require('od-modules/utils/tracking.utils');
const priceSubscriberMixin = require('od-modules/mixins/price_subscriber.mixin');
const searchTypes = {
    O: 'oneWayTrip',
    R: 'roundTrip',
    M: 'multipleTrip',
};
const scope = ['O', 'R'];
const sessionParam = 'fareFamiliesRequest';

module.exports = Odigeo.Model.extend(priceSubscriberMixin.extend({

    defaults: {
        search: {},
        details: {},
        data: {},
        emptyResponse: true,
        fareUpgrades: [],
        selectedIndex: 0,
        fareFamily: '',
        fareFamilyAmount: 0,
    },

    dataUrl: 'fareupgrades',

    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },
    initialize: function() {
        this.bindEvents();
        this.getFareFamiliesFromSession();
    },
    bindEvents: function() {
        this.bindPriceCollection();
        this.on('priceCollection.repaintPrices', this.repaintPrices);
    },
    repaintPrices: function() {
        this.trigger('repaintPrices');
    },
    populateData: function(data) {
        this.set({
            search: Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')),
            details: Odigeo.Utils.parseJson(Odigeo.Session.get('selectedCarriers')),
            data: data,
        });
    },
    getFlightSelectionFromSession: function() {
        return Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
    },
    getFareFamilyFromSession: function() {
        return Odigeo.Utils.parseJson(Odigeo.Session.get(sessionParam));
    },
    setFareFamilyFromSession: function() {
        Odigeo.Session.set(sessionParam, JSON.stringify(this.attributes));
    },
    fetchFareFamilies: function(data) {
        this.set(this.defaults);
        Odigeo.Session.remove(sessionParam);
        this.populateData(data);
        if (this.isInScope(data)) {
            Fetcher.post(this.url(), this.getDataRequestSettings()).json()
                .then((model) => this.onSuccess.call(this, model))
                .catch(() => this.onError.call(this));
        }
    },
    getDataRequestSettings: function() {
        return {
            data: this.get('data'),
            details: this.get('details'),
        };
    },
    onError: function() {
        Odigeo.trigger('fare-family-component:onContinueWithFlight', this.get('data'));
    },
    onSuccess: function(model) {
        this.set(model);
        this.set('emptyResponse', Odigeo._.isEmpty(this.get('fareUpgrades')));
        this.setFareFamilyFromSession();
        Odigeo.trigger('fare-family-component:onContinueWithFlight', this.get('data'));
    },
    getFareFamiliesFromSession: function() {
        const flightSelectionFromSession = this.getFlightSelectionFromSession();
        const sessionValue = this.getFareFamilyFromSession();
        if (sessionValue) {
            const flightNumbers = sessionValue.data.flightNumbers ? sessionValue.data.flightNumbers : sessionValue.data.data.segmentKeys;
            const flightNumbersFromSession = flightSelectionFromSession.data.flightNumbers || flightSelectionFromSession.flightNumbers;
            if (this.isSameFlight(flightNumbersFromSession, flightNumbers)) {
                this.set(sessionValue);
            }
            this.repaintPrices();
        }
    },
    setFareFamiliesMeta: function(data) {
        const fareUpgradeResponseDTO = data.get('fareUpgradesResponseDTO');
        const fareUpgrades= fareUpgradeResponseDTO ? fareUpgradeResponseDTO.fareUpgrades : [];
        const sessionValue = {
            fareUpgrades: fareUpgrades,
            search: Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')),
            details: Odigeo.Utils.parseJson(Odigeo.Session.get('selectedCarriers')),
            data: {
                data: {
                    segmentKeys: data.get('itinerarySearchRequest').externalSelectionRequest.segmentKeys,
                    searchId: data.get('searchId'),
                    fareItineraryKey: data.get('fareItineraryKey'),
                },
            },
            emptyResponse: Odigeo._.isEmpty(fareUpgrades),
        };
        Odigeo.Session.set(sessionParam, JSON.stringify(sessionValue));
    },
    getTemplateParams: function() {
        return {
            flightType: this.getFlightType(),
            carrierCode: this.getCarrierCode(),
            carrierName: this.getCarrierName(),
            selectedIndex: this.get('selectedIndex'),
        };
    },
    getCarrierCode: function() {
        return Odigeo._.get(this.get('details'), '[0].carriercode');
    },
    getCarrierName: function() {
        return Odigeo._.get(this.get('data'), 'data.carrierName');
    },
    getFlightType: function() {
        const type = Odigeo._.get(this.get('search'), 'type');
        return Odigeo._.invert(searchTypes)[type];
    },
    getPrice: function() {
        const data = this.get('data');
        const priceWithoutDiscountSelected = data.data.priceWithoutDiscountSelected;
        const selectedFareFamilyAmount = this.get('fareFamilyAmount');
        const discountPrice = this.getPriceCollectionData().totalTicketPricePerPax - selectedFareFamilyAmount;
        const price = this.getPriceCollectionData().totalPricePerPax - selectedFareFamilyAmount;
        return !Odigeo.Membership.isMembershipProductEnabled || priceWithoutDiscountSelected ? price : discountPrice;
    },
    sendOpenFaresTracking: function() {
        const fareFamilies = this.getFareFamilyFromSession();
        if (fareFamilies && !fareFamilies.emptyResponse && fareFamilies.fareUpgrades) {
            trackingUtils.trackEvent('pax_farefam', 'open_farefam:all-fare:' + fareFamilies.fareUpgrades.length);
        }
    },
    isSameFlight: function(current, stored) {
        return JSON.stringify(current) === JSON.stringify(stored);
    },
    isInScope: function() {
        return this.crossFaringRestriction() && this.searchTypesRestriction();
    },
    crossFaringRestriction: function() {
        const flights = this.get('details');
        const primitive = flights.map((flight) => flight.carriercode);
        const unique = primitive.filter((value, index, self) => self.indexOf(value) === index);
        return unique.length === 1;
    },
    searchTypesRestriction: function() {
        const search = this.get('search');
        const searchType = search.type;
        return scope.some((type) => searchTypes[type].toLowerCase().replace('_', '') === searchType.toLowerCase().replace('_', ''));
    },
}));
